import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <main className="mx-auto w-full max-w-2xl px-4 pb-12 pt-5">
      <Link className="rounded text-sm font-medium text-voto-muted hover:text-voto-fg" to="/">
        ‹ Back
      </Link>

      <h1 className="mt-5 text-2xl font-semibold tracking-tight text-white sm:text-3xl">
        Terms &amp; Conditions
      </h1>

      <div className="mt-6 divide-y divide-voto-line rounded-2xl bg-voto-surface px-5 text-[15px] leading-relaxed text-voto-muted ring-1 ring-voto-line [&>*]:py-5 [&_strong]:block [&_strong]:text-base [&_strong]:font-semibold [&_strong]:text-white">
        <section>
          <strong>1. Acceptance</strong>
          <p className="mt-2">
            By using votomoto you agree to be bound by these Terms. If you do not agree, do not use
            the service.
          </p>
        </section>

        <section>
          <strong>2. The Service</strong>
          <p className="mt-2">
            votomoto allows users to create photo comparison polls and enables others to vote, like,
            share, or comment on them. We may update or modify the service at any time.
          </p>
        </section>

        <section>
          <strong>3. Your Content</strong>
          <p className="mt-2">
            You retain ownership of content you post. By submitting content you grant votomoto a
            worldwide, non-exclusive, royalty-free license to use, reproduce, and display that
            content in connection with the service. You are solely responsible for ensuring you have
            the right to post any content you submit.
          </p>
        </section>

        <section>
          <strong>4. Prohibited Uses</strong>
          <p className="mt-2">You may not use the service to:</p>
          <ul className="mt-2 list-inside list-disc space-y-1 text-sm">
            <li>Post content that is abusive, obscene, or harassing</li>
            <li>Post content that infringes third-party intellectual property rights</li>
            <li>Attempt to gain unauthorized access to any part of the service</li>
            <li>Use automated means to scrape or harvest data</li>
            <li>Post spam or commercial advertising</li>
            <li>
              Post, share or request content that sexually abuses or exploits children (CSAE); see our{' '}
              <a href="/child-safety" className="text-voto-coral hover:underline">
                Child Safety Standards
              </a>
            </li>
          </ul>
          <p className="mt-3">
            <span className="font-semibold text-white">Zero tolerance.</span> Voto has no tolerance for
            objectionable content or abusive users. Anyone can report a poll or comment and block another
            user. We remove content that breaks these Terms and suspend or ban the accounts responsible.
          </p>
        </section>

        <section>
          <strong>5. Termination</strong>
          <p className="mt-2">
            We may suspend or terminate your access to the service at any time, with or without
            notice, for any reason including breach of these Terms.
          </p>
        </section>

        <section>
          <strong>6. Disclaimers</strong>
          <p className="mt-2">
            The service is provided "as is" without warranty of any kind. We do not warrant that the
            service will be uninterrupted, error-free, or free from bugs.
          </p>
        </section>

        <section>
          <strong>7. Limitation of Liability</strong>
          <p className="mt-2">
            votomoto shall not be liable for any indirect, special, incidental, or consequential
            damages arising out of your use of or inability to use the service.
          </p>
        </section>

        <section>
          <strong>8. Privacy</strong>
          <p className="mt-2">
            Use of the service is also governed by our{' '}
            <Link to="/privacy" className="text-voto-coral hover:underline">
              Privacy Policy
            </Link>
            .
          </p>
        </section>

        <section>
          <strong>9. Changes to These Terms</strong>
          <p className="mt-2">
            We may update these Terms at any time. Your continued use of the service constitutes
            acceptance of the updated Terms.
          </p>
        </section>

        <section>
          <strong>10. Contact</strong>
          <p className="mt-2">
            Questions?{' '}
            <a href="mailto:eric@ericstevenson.com" className="text-voto-coral hover:underline">
              eric@ericstevenson.com
            </a>
          </p>
        </section>
      </div>
    </main>
  );
}
